import { Header } from "components/Header";
import { DashboardTemplate } from "templates/DashboardTemplate";
import { Container } from "./styles";
import Modal from "react-modal";
import {
  ModalContent,
  ModalOverlay,
} from "components/Modals/ExportEfficiencyReportModal/styles";
import { useState } from "react";

export default function Manual() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openedModalName, setOpenedModalName] = useState("");
  return (
    <DashboardTemplate hasTableWrapper>
      <Header title="Manual de uso" />

      <Container>
        <table>
          <tr data-cy="manual-occurrence-row">
            <th>Ocorrência Manual</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarOcorrenciaPatrimonial");
                }}
              >
                Criar ocorrência patrimonial
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarOcorrenciaVeicular");
                }}
              >
                Criar ocorrência veicular
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("gerenciarOcorrenciaManual");
                }}
              >
                Gerenciar
              </button>{" "}
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("comentarOcorrencia");
                }}
              >
                Comentar{" "}
              </button>{" "}
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("compartilharOcorrencia");
                }}
              >
                Compartilhar{" "}
              </button>
            </tbody>
          </tr>
          <tr data-cy="mobile-occurrence-row">
            <th>Ocorrência Mobile</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarOcorrenciaPatrimonial");
                }}
              >
                Criar ocorrência patrimonial
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarOcorrenciaVeicular");
                }}
              >
                Criar ocorrência veicular
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("gerenciarOcorrenciaMobile");
                }}
              >
                Gerenciar
              </button>{" "}
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("comentarOcorrencia");
                }}
              >
                Comentar{" "}
              </button>{" "}
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("compartilharOcorrencia");
                }}
              >
                Compartilhar{" "}
              </button>
            </tbody>
          </tr>
          <tr data-cy="clients-row">
            <th>Clientes</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarCliente");
                }}
              >
                Cadastrar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("editarCliente");
                }}
              >
                Editar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("ativarCliente");
                }}
              >
                Ativar/desativar
              </button>
            </tbody>
          </tr>
          <tr data-cy="sub-clients-row">
            <th>Sub-clientes</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarSubcliente");
                }}
              >
                Cadastrar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarSubclienteEmLote");
                }}
              >
                Cadastrar em lote
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("ativarSubcliente");
                }}
              >
                Ativar/desativar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("editarSubcliente");
                }}
              >
                Editar
              </button>
            </tbody>
          </tr>
          <tr data-cy="users-row">
            <th>Usuário</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarUsuario");
                }}
              >
                Cadastrar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarUsuarioEmLote");
                }}
              >
                Cadastro em lote
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("ativarUsuario");
                }}
              >
                Ativar/desativar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("editarUsuario");
                }}
              >
                Editar
              </button>
            </tbody>
          </tr>
          <tr data-cy="policemen-row">
            <th>Agentes</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarAgente");
                }}
              >
                Cadastrar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarAgentesEmLote");
                }}
              >
                Cadastro em lote
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("ativarAgente");
                }}
              >
                Ativar/desativar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("editarAgente");
                }}
              >
                Editar
              </button>
            </tbody>
          </tr>
          <tr data-cy="providers-row">
            <th>Fornecedores</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarFornecedor");
                }}
              >
                Cadastrar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarFornecedoresEmLote");
                }}
              >
                Cadastro em lote
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("ativarFornecedor");
                }}
              >
                Ativar/desativar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("editarFornecedor");
                }}
              >
                Editar
              </button>
            </tbody>
          </tr>
          <tr data-cy="services-row">
            <th>Serviços</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarServico");
                }}
              >
                Cadastrar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("ativarServico");
                }}
              >
                Ativar/desativar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("editarServico");
                }}
              >
                Editar
              </button>
            </tbody>
          </tr>
          <tr data-cy="products-row">
            <th>Produtos</th>
            <tbody>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("criarProduto");
                }}
              >
                Cadastrar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("editarProduto");
                }}
              >
                Editar
              </button>
              <button
                onClick={() => {
                  setIsModalOpen(true);
                  setOpenedModalName("ativarProduto");
                }}
              >
                Ativar/desativar
              </button>
            </tbody>
          </tr>
        </table>
      </Container>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => {
          setIsModalOpen(false);
          setOpenedModalName("");
        }}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        contentElement={(props, children) => (
          <ModalContent {...props}>{children}</ModalContent>
        )}
        overlayElement={(props, contentElement) => (
          <ModalOverlay {...props}>{contentElement}</ModalOverlay>
        )}
      >
        {openedModalName === "criarOcorrenciaPatrimonial" && (
          <iframe
            data-cy="create-patrimonial-occurrence"
            title="Criar ocorrência patrimonial"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Como_criar_ocorrencia_patrimonial__3wDKwUfkQo-ppJF4yMfPLw"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarOcorrenciaVeicular" && (
          <iframe
            data-cy="create-vehicular-occurrence"
            title="Criar ocorrência veicular"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Como_criar_ocorrencia_veicular__nDgl_O8CT2GoUpcKwP1OFg"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "gerenciarOcorrenciaMobile" && (
          <iframe
            data-cy="manage-mobile-occurrence"
            title="Gerenciar ocorrência mobile"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Gerenciar_ocorrencia_Mobile__XRmMewnxRoaF8TeYF9mFAA"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "gerenciarOcorrenciaManual" && (
          <iframe
            data-cy="manage-manual-occurrence"
            title="Gerenciar ocorrencia Manual"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Gerenciar_ocorrencia_MANUAL__EUHcFXZMTburLIWrUu0vjA"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "comentarOcorrencia" && (
          <iframe
            data-cy="add-occurrence-comment"
            title="Comentar ocorrência"
            src="https://scribehow.com/shared/Adicionar_e_editar_comentarios_em_ocorrencia__HX_jL2A3TReFkmlkhO2Wpg"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "compartilharOcorrencia" && (
          <iframe
            data-cy="share-occurrence-link"
            title="Compartilhar ocorrência"
            src="https://scribehow.com/embed/Como_compartilhar_uma_ocorrencia__331aRMFGQIOG_RbMErNFHg"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarCliente" && (
          <iframe
            data-cy="create-client"
            title="Criar cliente"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Cadastro_de_clientes___NJK9d-VTTyYMqGhjIazRA"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "editarCliente" && (
          <iframe
            data-cy="edit-client"
            title="Editar cliente"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Edicao_de_clientes__Guthw7esTDqpp3f-IxZk5w"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "ativarCliente" && (
          <iframe
            data-cy="activate-client"
            title="Ativar cliente"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Busca_de_clientes_e_ativacaodesativacao_de_um_cliente__zcaSGmidTlOF6k37p481nw"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarSubcliente" && (
          <iframe
            data-cy="create-sub-client"
            title="Criar subcliente"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Criacao_de_sub-clientesbeneficiarios__WjhQDrt7Qv-2qX3xmOduqw"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "editarSubcliente" && (
          <iframe
            data-cy="edit-sub-client"
            title="Editar subcliente"
            src="https://scribehow.com/shared/Editar_subcliente__EAhpis9TRWW1AOKJdP-r1w"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "ativarSubcliente" && (
          <iframe
            data-cy="activate-sub-client"
            title="Ativar subcliente"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Busca_e_ativacaodesativacao_de_um_sub-clientebeneficiario__EAy1dui-TiW1fQ8La89qww"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarSubclienteEmLote" && (
          <iframe
            data-cy="create-many-sub-client"
            title="Criar subcliente em lote"
            src="https://scribehow.com/embed/Criar_subcliente_em_lote__cqafx3oxQgKPWZ_tt2VkUQ"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarAgente" && (
          <iframe
            data-cy="create-policeman"
            title="Criar agente"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Cadastrar_agente__Ll7Q7VgQRcSMDlOlQQ0kBg"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarAgentesEmLote" && (
          <iframe
            data-cy="create-many-policeman"
            title="Criar agentes em lote"
            src="https://scribehow.com/embed/Criacao_de_pronta_respostas_em_lote__sw5xzhOMTYqQhDa5Cjbs8g"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "editarAgente" && (
          <iframe
            data-cy="edit-policeman"
            title="Editar agente"
            src="https://scribehow.com/shared/TUTORIAL_PRESERAPP__Edicao_de_Pronta-resposta__xZV8OViKRhGPetwLagsnQw"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "ativarAgente" && (
          <iframe
            data-cy="activate-policeman"
            title="Criar agente em lote"
            src="https://scribehow.com/shared/AtivarDesativar_um_Pronta-resposta__DTAe9O23TBmvRT7-UBgEbg"
            width="100%"
            height="640"
          />
        )}

        {openedModalName === "criarUsuario" && (
          <iframe
            data-cy="create-user"
            title="Criar usuário"
            src="https://scribehow.com/shared/Criar_usuario__epN2dB_wSNmmlFXna5p14Q"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "editarUsuario" && (
          <iframe
            data-cy="edit-user"
            title="Editar usuário"
            src="https://scribehow.com/shared/Editar_Usuario__lo1akIH7SLuwjAK_mMmkjQ"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarUsuarioEmLote" && (
          <iframe
            data-cy="create-many-user"
            title="Criar usuário em lote"
            src="https://scribehow.com/embed/Criar_usuario_em_lote__2uvi4C3ZQD-9xdSQJSA9CQ"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "ativarUsuario" && (
          <iframe
            data-cy="activate-user"
            title="Ativar usuário"
            src="https://scribehow.com/shared/Ativardesativar_usuario__6IleleEZRcyR1WP_KOUZrg"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarFornecedor" && (
          <iframe
            data-cy="create-provider"
            title="Criar fornecedor"
            src="https://scribehow.com/shared/Criar_Fornecedor__7nH8HkYARKOAJaca5GYvZA"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "editarFornecedor" && (
          <iframe
            data-cy="edit-provider"
            title="Editar fornecedor"
            src="https://scribehow.com/shared/Editar_Fornecedor__yk-A4lbOSTyM7vjcBryMjQ"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "ativarFornecedor" && (
          <iframe
            data-cy="activate-provider"
            title="Ativar fornecedor"
            src="https://scribehow.com/shared/AtivarDesativar_fornecedor__gdfxX_YdR3Cakp9bWaoTjA"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarFornecedoresEmLote" && (
          <iframe
            data-cy="create-many-provider"
            title="Criar fornecedores em lote"
            src="https://scribehow.com/shared/Criar_fornecedores_em_lote__SoMKvE6zQNimHrc_xx95ww"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarServico" && (
          <iframe
            data-cy="create-service"
            title="Criar serviço"
            src="https://scribehow.com/shared/Criar_um_Servico__-JtDslv8RXiDW50mOlflrg"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "editarServico" && (
          <iframe
            data-cy="edit-service"
            title="Editar serviço"
            src="https://scribehow.com/shared/Editar_um_Servico__mSDPsZJ6SX6FjyE7biO1iw"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "ativarServico" && (
          <iframe
            data-cy="activate-service"
            title="Ativar serviço"
            src="https://scribehow.com/shared/Ativar_ou_desativar_Servico__xX3B-3FFTji7W1QOvK7DMw"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "criarProduto" && (
          <iframe
            data-cy="create-product"
            title="Criar produto"
            src="https://scribehow.com/shared/Criar_Produto__lEYcJj5JQ8iSCrReg2Pw_g"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "editarProduto" && (
          <iframe
            data-cy="edit-product"
            title="Editar produto"
            src="https://scribehow.com/shared/Editar_Produto__JSm1fPz9SN6HeCnJMCpfeA"
            width="100%"
            height="640"
          />
        )}
        {openedModalName === "ativarProduto" && (
          <iframe
            data-cy="activate-product"
            title="Ativar produto"
            src="https://scribehow.com/shared/Como_ativardesativar_produtos__zBMwo_CPTry8kRwaBOnyHA"
            width="100%"
            height="640"
          />
        )}
      </Modal>
    </DashboardTemplate>
  );
}
